const EmotionFace = ({ emotion, face, label, onClick, bgColor, borderColor }) => (
  <button
    onClick={onClick}
    data-testid={`emotion-button-${emotion}`}
    className={`flex flex-col items-center gap-0.5 sm:gap-1 p-1.5 sm:p-3 rounded-2xl font-semibold transition-all duration-200 hover:scale-110 active:scale-95 ${bgColor} border-2 ${borderColor}`}
    style={{ minWidth: '52px' }}
  >
    <span className="text-xl sm:text-3xl">{face}</span>
    <span className="text-[9px] sm:text-xs font-medium">{label}</span>
  </button>
);

export default EmotionFace;
